import { Theme } from "../../../components/constants" 

export default {
    loginForm:{
        display: "flex",
        flexDirection: "column",
        padding: "15px",
        width: "100%",
    },
    marginTop: {
        marginTop: "30px",
    },
    forgotPasswordDiv:{
        marginTop: "8px",
    },
    forgotPasswordLink: {
        fontWeight: 700,
        fontSize: "14px",
        lineHeight: "18px",
        color: Theme.PRIMARY,
    },
    signInButtonDiv: {
        width: "100%",
        marginTop: "10px",
    },
    signWithOptionsMainContainer:{
        marginTop: "30px",
    },
    signInOptionsTitle: {
        fontSize: "14px",
        lineHeight: "18px",
        marginBottom: "10px",
        textAlign: "center",
    },
    signInOptionsContainer: {
        display: "flex",
        flexWrap: "wrap",
        gap: "10px",
        justifyContent: "center",
        alignItems: "center",
    },
    signInOptionDiv: {
        border: `0.5px solid ${Theme.PRIMARY_BORDER}`,
        borderRadius: "4px",
        height: "69px",
        width: "85px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    signUpOptionContainer: {
        display: "flex",
        flexDirection: "row",
        marginTop: "10px",
        fontSize: "14px",
    },
    separatorDiv: {
        marginTop: "20px",
    },
    signUpLink: {
        marginLeft: "6px",
    },
    errorMessageContainer: {
        minHeight: "22px",
        marginTop: "20px",
    },
    errorMessage: {
        fontSize: "16px",
        lineHeight: "20px",
        color: Theme.ERROR_TEXT,
    },
    TFA_mainContainer: {
        display:'flex', 
        flexDirection: 'column', 
        gap: '40px'
    },
    alignSelfCenter: {
        alignSelf: 'center'
    },
    TFA_Label: {
        fontSize: "16px", 
        color: Theme.DISABLED_TEXT
    },
    textAlignCenter: {
        textAlign: 'center'
    },
    TFA_verifyButton: {
        padding: '10px 25px', 
        marginTop: '20px'
    },
    appleLoginButton: { width: "40px", height: "40px", border: "1px solid #dadce0", background: "white", padding: "0px" }
}